import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { ServiceCard } from "@/components/site/ServiceCard";
import { POSITIONING } from "@/lib/site";

export const JourneyIntro = ({ journey, onStart, onGuidanceNow, headingRef }) => {
  const quick = (journey.intro_services || []).map((s) => journey.services_catalog.find((x) => x.slug === s)).filter(Boolean);
  return (
    <section className="relative overflow-hidden grain" data-testid="journey-intro">
      <div className="container-site max-w-3xl pt-12 pb-20 md:pt-20 animate-fade-up">
        <div className="flex items-center justify-between gap-3">
          <Link to="/find-your-way" className="btn-ghost text-sm" data-testid="journey-all-situations-link">All situations</Link>
          <Link to="/urgent-help" className="text-sm font-semibold text-clay-dark underline underline-offset-4" data-testid="journey-intro-help-now-link">Need help now?</Link>
        </div>
        <h1 ref={headingRef} tabIndex={-1} className="focus-visible:outline-none mt-8 text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="journey-intro-headline">{journey.intro.headline}</h1>
        <p className="mt-6 text-lg md:text-xl text-ink-soft max-w-2xl">{journey.intro.text}</p>
        {quick.length > 0 && (
          <div className="mt-8 grid gap-4 sm:grid-cols-2" data-testid="journey-intro-services">
            {quick.map((s) => <ServiceCard key={s.slug} entry={s} compact />)}
            <p className="sm:col-span-2 text-sm text-ink-muted">Independent UK organisations. In immediate danger, call <a href="tel:999" className="underline font-semibold">999</a>.</p>
          </div>
        )}
        <button type="button" onClick={onStart} className="btn-primary mt-9 w-full sm:w-auto !text-lg !px-8 !py-4" data-testid="journey-start-button">
          {journey.intro.cta} <ArrowRight className="h-5 w-5" aria-hidden="true" />
        </button>
        <p className="mt-4 flex items-center gap-2 text-sm text-ink-muted" data-testid="journey-intro-microcopy"><ShieldCheck className="h-4 w-4 shrink-0" aria-hidden="true" />{journey.intro.microcopy}</p>
        <p className="mt-3 text-sm text-ink-muted max-w-2xl" data-testid="journey-intro-positioning">{POSITIONING}</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-6 text-[0.95rem]">
          <button type="button" onClick={onGuidanceNow} className="btn-ghost text-left" data-testid="journey-guidance-now-button">I'd rather see the guidance now</button>
          {journey.has_guide && <Link to={`/find-your-way/${journey.pathway_slug}/guide`} className="btn-ghost" data-testid="journey-full-guide-link">Read the full guide</Link>}
        </div>
      </div>
    </section>
  );
};
